import React, { useCallback, useMemo, useState } from 'react';

import { Drawer, IconButton, SvgIcon } from '@mui/material';

import IconClose from 'app/ui-kit/icons/Close.svg';
import IconMenu from 'app/ui-kit/icons/Menu.svg';
import MenuList from 'pages/layout/components/MenuList';

import DrawerMenuContext from './drawer-menu-context';
import useStyles from './styles';

interface Props {
    className?: string;
}

const DrawerMenuButton: React.FC<Props> = ({ className }) => {
    const { classes } = useStyles();

    const [isOpen, setIsOpen] = useState(false);
    const close = useCallback(() => setIsOpen(false), []);
    const open = useCallback(() => setIsOpen(true), []);
    const toggle = useCallback(() => setIsOpen((state) => !state), []);

    const drawerContextValue = useMemo(
        () => ({
            isOpen,
            close,
            open,
            toggle
        }),
        [close, isOpen, open, toggle]
    );

    return (
        <DrawerMenuContext.Provider value={drawerContextValue}>
            <DrawerMenuContext.Consumer>
                {({ isOpen, toggle, close }) => (
                    <>
                        <IconButton size="small" onClick={toggle} className={className}>
                            <SvgIcon>{isOpen ? <IconClose /> : <IconMenu />}</SvgIcon>
                        </IconButton>
                        <Drawer anchor="left" open={isOpen} onClose={close} className={classes.drawer}>
                            <MenuList showSearchBar onMenuItemClick={close} />
                        </Drawer>
                    </>
                )}
            </DrawerMenuContext.Consumer>
        </DrawerMenuContext.Provider>
    );
};

export default DrawerMenuButton;
